import React, { useState } from "react";
import { graphql, navigate } from "gatsby";
import Layout from "@qlik/qlik/src/components/Layout";
import Seo from "@qlik/qlik/src/components/Seo";
import FormSuccessFeedback from "@qlik/qlik/src/components/Common/FormSuccessFeedback";
import useFormSession from "@qlik/qlik/src/hooks/useFormSession";
import { TYPE_MARKETO_FORM } from "@qlik/qlik/src/lib/constants/contentful-types";
import { RESOURCE_GATED_LOADING_TEXT, RESOURCE_PATHNAME } from "@qlik/qlik/src/lib/constants/resource-constants";
import { getGatedContentComponent, getMicrocopyValueFromKeys } from "@qlik/qlik/src/lib/util/helpers";

export const query = graphql`
    query($id: String, $headerName: String, $locale: String) {
        contentfulHeader(name: { eq: $headerName }, node_locale: { eq: $locale }) {
            ...Header
        }
        contentfulResource(id: { eq: $id }) {
            ...Resource
        }
        contentfulFooter(name: { eq: "Full footer" }, node_locale: { eq: $locale }) {
            ...Footer
        }
        contentfulThemeSettings(node_locale: { eq: $locale }) {
            ...ThemeSettings
        }
    }
`;

/**
 * Component to render on Gated Resource Form Success
 * @param {*} param0
 * @returns
 */
const ResourceFormSuccess = ({ data }) => {
    const { slug, cta = [] } = data?.contentfulResource ?? {};
    const [isLoading, setIsLoading] = useState(true);
    const { resourceMicrocopyGroup } = data?.contentfulThemeSettings || {};

    // check if form is already submitted & not expired or not submitted previously at all
    // navigate back to gated page
    const onFormInvalid = () => {
        navigate("../");
        return null;
    };

    const gatedContent = getGatedContentComponent(data?.contentfulResource);

    const formCard = gatedContent?.cardItems?.find((card) => card.__typename === TYPE_MARKETO_FORM);
    useFormSession(formCard?.formId, () => setIsLoading(false), onFormInvalid, onFormInvalid);

    const [resourceGatedLoadingText] = getMicrocopyValueFromKeys(resourceMicrocopyGroup, [RESOURCE_GATED_LOADING_TEXT]);

    return (
        <Layout
            headerData={data.contentfulHeader}
            minimalHeaderData={data.contentfulThemeSettings?.minimalNavPages}
            footerData={data.contentfulFooter}
            pageSlug={slug}
        >
            <Seo
                data={data.contentfulResource.metadata}
                pageSlug={`${RESOURCE_PATHNAME}${slug?.startsWith("/") ? "" : "/"}${slug}`}
            />
            {isLoading ? (
                <p className="text-center py-20 lg:py-30 text-5xl">{resourceGatedLoadingText}</p>
            ) : (
                <FormSuccessFeedback
                    data={{ ...data?.contentfulResource, microcopyGroup: resourceMicrocopyGroup }}
                    downloadable={cta?.[0]}
                />
            )}
        </Layout>
    );
};

export default ResourceFormSuccess;
